export default __webpack_public_path__ + "static/media/WNo.1-0.eda14893.jpg";